var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingRecords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.625C6 5.51839 8.51839 3 11.625 3H24.375C27.4816 3 30 5.51839 30 8.625V31.875C30 32.316 29.7424 32.7162 29.341 32.8989C28.9396 33.0816 28.4687 33.0129 28.1361 32.7234L25.0386 30.0255L22.2808 32.6848C21.8451 33.105 21.155 33.105 20.7191 32.6848L18 30.0629L15.2809 32.6848C14.8451 33.105 14.1549 33.105 13.7191 32.6848L10.9613 30.0255L7.86388 32.7234C7.53136 33.0129 7.06031 33.0816 6.65897 32.8989C6.25763 32.7162 6 32.316 6 31.875V8.625ZM12 11.625C12 11.0037 12.5037 10.5 13.125 10.5H22.875C23.4963 10.5 24 11.0037 24 11.625C24 12.2463 23.4963 12.75 22.875 12.75H13.125C12.5037 12.75 12 12.2463 12 11.625ZM12 17.625C12 17.0037 12.5037 16.5 13.125 16.5H16.875C17.4963 16.5 18 17.0037 18 17.625C18 18.2463 17.4963 18.75 16.875 18.75H13.125C12.5037 18.75 12 18.2463 12 17.625Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingRecords);
export default __webpack_public_path__ + "static/media/billing-records.42242498096fc88949f65fea311e6f16.svg";
export { ForwardRef as ReactComponent };